module.exports = __webpack_public_path__ + "img/qris-dana.b959c647.png";